import { render, staticRenderFns } from "./tabList.vue?vue&type=template&id=1380068e&scoped=true&"
import script from "./tabList.vue?vue&type=script&lang=js&"
export * from "./tabList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380068e",
  null
  
)

export default component.exports